/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerNotificationEventEnumType } from "./CustomerNotificationEventEnum"
import { RootStoreType } from "./index"


/**
 * CustomerNotificationTemplatePlaceholdersDtoBase
 * auto generated base class for the model CustomerNotificationTemplatePlaceholdersDtoModel.
 */
export const CustomerNotificationTemplatePlaceholdersDtoModelBase = ModelBase
  .named('CustomerNotificationTemplatePlaceholdersDto')
  .props({
    __typename: types.optional(types.literal("CustomerNotificationTemplatePlaceholdersDto"), "CustomerNotificationTemplatePlaceholdersDto"),
    event: types.union(types.undefined, CustomerNotificationEventEnumType),
    placeholders: types.union(types.undefined, types.array(types.string)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerNotificationTemplatePlaceholdersDtoModelSelector extends QueryBuilder {
  get event() { return this.__attr(`event`) }
  get placeholders() { return this.__attr(`placeholders`) }
}
export function selectFromCustomerNotificationTemplatePlaceholdersDto() {
  return new CustomerNotificationTemplatePlaceholdersDtoModelSelector()
}

export const customerNotificationTemplatePlaceholdersDtoModelPrimitives = selectFromCustomerNotificationTemplatePlaceholdersDto().event.placeholders
